import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-insightsslider',
  templateUrl: './insightsslider.component.html',
  styleUrls: ['./insightsslider.component.css']
})
export class InsightssliderComponent implements OnInit{
  sliderData: any[] = [];
  currentIndex: number = 0;

  constructor() { }
  ngOnInit(): void {
    this.sliderData = this.updateSliderData();
  }

  updateSliderData(): any[] {
    return [
      {
        id: 1,
        class: "insights_active",
        headerText: `<span>The Future of Marketing Personalization: AI-Powered Journeys</span>`,
        bodyText: `Across the entire customer journey, AI is assisting marketers in providing more helpful, enjoyable experiences for shoppers and improving performance: from one-to-one messaging that doesn't sound like spam, to dynamic website design that adapts to individual users. Find how retail stores can capitalize on this technology trend.`,
        readMore: ``,
        img: `<img src="../../../assets/js/insights/insight-newsliderimage.png" class="img img-responsive w-100-h-100" alt="firstslider">`,
      },
      {
        id: 2,
        class: "semi_insights_active",
        headerText: `<span>Embracing the next era of Digital: From Survival, Thriving to Reinvigorating</span>`,
        bodyText: `Digital has become the default. The question now no longer remains whether digital is an avenue for business, but about how it’s put into use. Learn How far businesses have progressed into the digital post-pandemic and how far they can go to adapt to the changing customer mindset.`,
        readMore: ``,
        img: `<img src="../../../assets/js/insights/insight-newsliderimage2.png" class="img img-responsive w-100-h-100" alt="secondslider">`,
      },
      {
        id: 3,
        class: "",
        headerText: `<span>Why is Cloud migration critical in the COVID-19 scenario</span>`,
        bodyText: `In just a few months, COVID19 had brought about years of change in the way businesses operate. It has pushed businesses to uncertainties that brought negative impact in terms of risks, closures, maintenance, operations, making several businesses financially fragile and at the edge of risk.`,
        readMore: ``,
        img: `<img src="../../../assets/js/insights/insight-newsliderimage3.png" class="img img-responsive w-100-h-100" alt="thirdslider">`,
      }
    ];

    
  }

  onNextClick() {
    this.currentIndex = (this.currentIndex + 1) % this.sliderData.length;
  }

  onPreviousClick() {
    this.currentIndex = (this.currentIndex - 1 + this.sliderData.length) % this.sliderData.length;
  }
}
